import instance from "@/utils/instance";

// ========== 个人版（consumer）登录接口 ==========

//发送验证码
export function getMemberSms(params) {
    return instance.get(`/webL_api/consumer/member/sms/${params}`)
}

//用户登录
export function postMemberLogin(params) {
    return instance.post(`/webL_api/consumer/member/login`,params)
}

//用户登出
export function postMemberLogout() {
    return instance.delete(`/webL_api/consumer/member/logout`)
}

//获取code值--未用到
export function getMemberLoginCode(params) {
    return instance.get(`/webL_api/third/wechat/queryCode/${params}`)
}

//获取登录链接
export function getMemberLoginUrl(params) {
    return instance.get(`/webL_api/third/wechat/getLoginCode/${params}`)
}

//绑定微信
export function postMemberBind(params) {
    return instance.get(`/webL_api/consumer/member/bind/wechat/${params}`)
}

// ========== 企业版（corporate）登录接口 ==========

//校验手机号是否已注册企业
export function getMemberCheckPhone(params) {
    return instance.get(`/webL_api/corporate/acc/hadAccount/${params}`)
}

//发送验证码-企业
export function getEnterpriseSms(params) {
    return instance.get(`/webL_api/corporate/acc/sms/${params}`)
}

//用户登录-企业
export function postEnterpriseLogin(params) {
    return instance.post(`/webL_api/corporate/acc/login`,params)
}

//用户登出-企业
export function postEnterpriseLogout() {
    return instance.delete(`/webL_api/corporate/acc/logout`)
}

//绑定微信-企业
export function postEnterpriseBind(params) {
    return instance.get(`/webL_api/corporate/acc/bind/wechat/${params}`)
}

